"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildEmptyMapMetadata = buildEmptyMapMetadata;
function buildEmptyMapMetadata() {
    return new Map();
}
//# sourceMappingURL=buildEmptyMapMetadata.js.map